// extracted by mini-css-extract-plugin
export var animateCircle = "main-badges-module--animate-circle--+GXYn";
export var badges = "main-badges-module--badges--Ozjka";
export var bounce = "main-badges-module--bounce--bGdmu";
export var description = "main-badges-module--description--YUF40";
export var item = "main-badges-module--item--t2qF0";
export var ldsRing = "main-badges-module--lds-ring--kGZ4e";
export var wrap = "main-badges-module--wrap--9x7UO";